import createLucideIcon from '../createLucideIcon';

const ChevronRight = createLucideIcon('ChevronRightIcon', [
  ['path', { d: 'm9 18 6-6-6-6', key: 'mthhwq' }],
]);

export default ChevronRight;
